import { render } from "./logoHead.vue?vue&type=template&id=4c829ff4&scoped=true"
import script from "./logoHead.vue?vue&type=script&lang=js"
export * from "./logoHead.vue?vue&type=script&lang=js"

import "./logoHead.vue?vue&type=style&index=0&id=4c829ff4&scoped=true&lang=css"
import "./logoHead.vue?vue&type=style&index=1&id=4c829ff4&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c829ff4"]])

export default __exports__